<script setup lang="ts">
import EntrRepeatedClickCounter from './EntrRepeatedClickCounter.vue';

const HARD_RESET_CLICKS = 5;
const HARD_RESET_SHOW_AFTER = 3;

withDefaults(
  defineProps<{
    label?: string;
  }>(),
  {
    label: 'Reset',
  }
);

const emit = defineEmits<{
  reset: [];
  hardReset: [];
}>();

function handleKeydown(event: KeyboardEvent): void {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    emit('reset');
  }
}
</script>

<template>
  <div
    class="reset-logo"
    :title="label"
    :aria-label="label"
    role="button"
    tabindex="0"
    data-testid="entr-reset-logo"
    @keydown="handleKeydown"
  >
    <slot />
    <EntrRepeatedClickCounter
      class="counter"
      :count="HARD_RESET_CLICKS"
      :show-after-clicks="HARD_RESET_SHOW_AFTER"
      @start="$emit('reset')"
      @success="$emit('hardReset')"
    />
  </div>
</template>

<style scoped>
.reset-logo {
  position: fixed;
  top: 1rem;
  left: 1rem;
  z-index: 9999;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
  cursor: pointer;
  transition: opacity 200ms ease;
}

.reset-logo:hover,
.reset-logo:focus-visible {
  opacity: 1;
}

.counter {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% + 4rem);
  height: 100%;
  cursor: pointer;
}
</style>
